<script lang="ts">
	import { Toaster } from 'svelte-french-toast';
</script>

<Toaster
	position="bottom-left"

	toastOptions={{
		style:
			'font-size: 0.85rem; border-radius: 10px; padding: 10px 14px; ' +
			'background: var(--panelSolid); color: var(--text); ' +
			'border: 0.36px solid var(--border); ' +
			'box-shadow: 0px 5px 6px -4px rgba(0,0,0,0.1), 0px 13px 16px -3px rgba(0,0,0,0.1);',
	}}
/>
